import { Box, Drawer, List } from "@mui/material";
import colorConfigs from "./colourConfigs";
import sizeConfigs from "./sizeConfigs";
import appRoutes from "../docs/appRoutes";
import SidebarItem from "./SidebarItem";
import SidebarItemCollapse from "./SidebarItemCollapse";

const Sidebar = ({ window, mobileOpen, setMobileOpen, handleDrawerToggle }) => {
  const drawer = (
    <>
      <List disablePadding style={{ marginTop: "20px" }}>
        {appRoutes.map((route, index) =>
          route.sidebarProps ? (
            route.child ? (
              <SidebarItemCollapse item={route} key={index} />
            ) : (
              <SidebarItem item={route} key={index} />
            )
          ) : null
        )}
      </List>
    </>
  );

  return (
    <Box>
      <Drawer
        container={
          window !== undefined ? () => window().document.body : undefined
        }
        variant="temporary"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "flex", md: "none" },
          width: sizeConfigs.sidebar.width,
          // position: "relative",
          flexShrink: 0,
          borderRight: "none",
          "& .MuiDrawer-paper": {
            borderRight: "none",
            position: "relative",
            width: sizeConfigs.sidebar.width,
            boxSizing: "border-box",
            backgroundColor: colorConfigs.sidebar.bg,
            color: colorConfigs.sidebar.color,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", md: "block" },
          width: sizeConfigs.sidebar.width,
          flexShrink: 0,
          position: "relative",
          borderRight: "none",
          "& .MuiDrawer-paper": {
            position: "relative",
            borderRight: "none",
            width: sizeConfigs.sidebar.width,
            boxSizing: "border-box",
            backgroundColor: colorConfigs.sidebar.bg,
            color: colorConfigs.sidebar.color,
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
};

export default Sidebar;
